import menuCategoryApi from '@/api/menu-category'
import { generateFormHandlerMutations } from '@/helpers/forms'
import form from './form'
import store from '@/store'

const state = {
  list: [],
  params: null,
}

const getters = {}

const actions = {
  fetchList({ commit }) {
    menuCategoryApi.getAll(state.params)
      .then(({ data }) => commit('SET_LIST', data))
  },
}

const modules = {
  form,
}

const mutations = {
  SET_LIST(state, items) {
    state.list = items
  },
  CLEAR_ERRORS(state) {
    state.errors = []
  },
  ...generateFormHandlerMutations(state),
}

const watchers = []

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers,
}
